import React from "react";
import { Link } from "react-router-dom";
import { FaComments, FaMapMarkerAlt, FaUniversity, FaStar } from "react-icons/fa";
import UserAvatar from "./UserAvatar";

function getDisplayName(user) {
  if (!user) return "";
  return `${user.Name || ""} ${user.LastN || ""}`.trim() || user.Name || "";
}

function TransactionUserChip({
  user,
  roleLabel,
  onOpenProfile,
  conversationId,
  onClickChat,
  transactionId,
  onViewAddress,
  onViewTransfer,
  onViewCalification,
}) {
  if (!user) return null;

  const displayName = getDisplayName(user);
  const username = user.Username ? `@${user.Username}` : "";
  const chatConversationId = conversationId || user.ConversationId;

  return (
    <div className="transaction-card__user">
      {(roleLabel || transactionId) && (
        <div className="transaction-card__user-head">
          {roleLabel && (
            <span className="transaction-card__user-label">{roleLabel}</span>
          )}
          {transactionId && (
            <span className="transaction-card__id">{transactionId}</span>
          )}
        </div>
      )}
      <div className="transaction-card__user-row">
        <button
          type="button"
          className="transaction-card__user-trigger"
          onClick={() => onOpenProfile(user)}
        >
          <UserAvatar
            src={user.Avatar}
            alt={displayName}
            verified={user.Verified}
            user={user}
            size="sm"
            imgClassName="transaction-card__user-avatar"
            initials={(displayName || "?").charAt(0).toUpperCase()}
          />
          <span className="transaction-card__user-text">
            {displayName && (
              <span className="transaction-card__user-name">{displayName}</span>
            )}
            {username && (
              <span className="transaction-card__user-username">{username}</span>
            )}
          </span>
        </button>
        {onViewAddress && (
          <button
            type="button"
            className="transaction-card__user-location"
            onClick={onViewAddress}
            aria-label="Location"
          >
            <FaMapMarkerAlt />
          </button>
        )}
        {onViewTransfer && (
          <button
            type="button"
            className="transaction-card__user-bank"
            onClick={onViewTransfer}
            aria-label="Transfer"
          >
            <FaUniversity />
          </button>
        )}
        {onViewCalification && (
          <button
            type="button"
            className="transaction-card__user-rating"
            onClick={onViewCalification}
            aria-label="Calification"
          >
            <FaStar />
          </button>
        )}
        {chatConversationId && (
          <Link
            className="transaction-card__user-chat"
            to={`/chat/${chatConversationId}`}
            onClick={onClickChat}
            aria-label="Chat"
          >
            <FaComments />
          </Link>
        )}
      </div>
    </div>
  );
}

export default TransactionUserChip;
